import { defineStore } from 'pinia';
import { ref, computed } from 'vue';

import useUserComposable from '@/composables/UserComposable';
import GlobalRequest from '@/api/global-request';
import { showToast } from '@/helpers/toast-handler';

import { formatTreeData, getFlattenArray } from '@/helpers/json-formatter';
const CATEGORY_URL = 'v2/template/category';
const ASSESSMENT_CATEGORY_URL = 'v2/template/assessment/categories';

export const useCategoryStore = defineStore('category', () => {
    const { company_id } = useUserComposable();
    // states
    const category = ref({
        company_id: null,
        name: null,
        parent_id: null,
    });
    const categories = ref([]);
    const assessmentCategories = ref([]);

    // getters
    const allCategories = computed(() => {
        return formatTreeData(categories.value);
    });

    const flattendCategories = computed(() => {
        return getFlattenArray(categories.value);
    });

    // actions
    // By default it will fetch categories for attributes and blocks types only
    const fetchCategories = async (assessmentType = false) => {
        try {
            const URL = assessmentType ? ASSESSMENT_CATEGORY_URL : CATEGORY_URL;
            const response = await GlobalRequest.getRequest(URL, {
                params: {
                    company_id: company_id.value,
                },
            });
            if (response.statusCode === 200) {
                assessmentType ? (assessmentCategories.value = response.data) : (categories.value = response.data);
            }
        } catch (error) {
            showToast({}, error?.data?.message ?? 'Failed to fetch categories');
        }
    };

    return {
        // states
        category,
        categories,
        assessmentCategories,
        // getters
        allCategories,
        flattendCategories,
        // actions
        fetchCategories,
    };
});
